import type { Tourist, Error } from '@lt/api/dist/methods/tourists/types';
import type { DOC_TYPE, TOURIST_VALIDATE } from '@lt/api/dist/types/tourists';

import { isChild } from 'src/components/Tourists/utils';
import type { TouristsState } from '../tourists/slice';

/**
 * Забираем текст ошибки из поля description
 */
export const getFlatErrors = (errors: Error[] = []) =>
  errors.map((error) => error.description);

/**
 * Возвращаем ошибки туристов в виде массива строк
 *
 * Пример изначального объекта с ошибками
 * @see 'src/api/mockServer/routes/tourists/fixtures/validate/tourist.ts'
 */
export const getTouristValidationErrorsList = (errors: Tourist) => {
  const list = [] as string[];
  const fields = Object.keys(errors) as Array<keyof typeof errors>;

  fields.forEach((fieldName) => {
    const field = errors[fieldName];
    const fieldErrors = getFlatErrors(field);

    list.push(...fieldErrors);
  });

  return list;
};

/**
 * Трансформирует объект туриста для ручки tourists/validate
 */
export const getTouristPayload = (tourist: TouristsState) => {
  const {
    name: touristName = '',
    surname = '',
    patronymic,
    passport_number = '',
    passport_expires_on = '',
    birthday = '',
    docType,
    gender,
    nationality_id,
    age,
  } = tourist;

  const TYPES: {
    [K in DOC_TYPE]: TOURIST_VALIDATE;
  } = {
    birth_certificate: {
      doc_type: docType,
      document_number: passport_number,
      gender,
      nationality_id,
      child: isChild(age),
      name: touristName,
      surname,
      patronymic,
      birthday,
    },
    international_passport: {
      doc_type: docType,
      document_number: passport_number,
      document_expires_on: passport_expires_on,
      gender,
      nationality_id,
      child: isChild(age),
      name: touristName,
      surname,
      birthday,
      patronymic,
    },
    internal_passport: {
      doc_type: docType,
      document_number: passport_number,
      gender,
      nationality_id,
      child: isChild(age),
      name: touristName,
      surname,
      patronymic,
      birthday,
    },
  } as const;

  return TYPES[docType];
};
